import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getMisc() {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: '/v1/misc/',
      method: HttpMethod.GET
    };

    const res = await processRequest(ep);

    const { data } = res;

    return data;
  },

  async getMiscV2() {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v2/misc/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);
      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getValidator() {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/users/validators/',
      method: HttpMethod.GET
    };

    const res = await processRequest(ep);

    const { data } = res;

    return data;
  },

  async getValuators() {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v2/valuators/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);
      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
